import React from "react"
import api from "src/api"

export function useGetPush() {
  const [pagination, setPagination] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [items, setItems] = React.useState([])

  async function getItems(page = 1, countOnPage = 20) {
    setIsLoading(true)
    try {
      const response = await api.get(
        `mailing-notifications?page=${page}&pageSize=${countOnPage}`,
          { useMailingApi: true }
      )
      setPagination({
        current: response.data.pagination.page,
        pageSize: response.data.pagination.pageSize,
        total: response.data.pagination.total,
      })
      setItems(response.data.items)

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    getItems()
  }, [])

  function handleTableChange(pagination) {
    getItems(pagination.current, pagination.pageSize)
  }


  return {
    items,
    pagination,
    isLoading,
    refetch: () => getItems(),
    handleTableChange,
  }
}


export function getFormattedItems(items) {
  const data = items.map((item) => {
    return {
      key: item.id,
      id: item.id,
      body: item.body,
      title: item.title,
      notificationCategory: item.notificationCategory,
      availableAt: item.availableAt,
      totalCountUser: item.totalCountUser,
      deliveredCountUser: item.deliveredCountUser,
    }

  })

  return data
}
